export class ParentChildHistory {
  private static _backward: string[] = []

  public static get backward(): string | undefined {
    return this._backward[this._backward.length - 1]
  }

  public static push(current: string, next: string) {
    if (next === this.backward) {
      this._backward.pop()
    } else {
      this._backward.push(current)
    }
  }

  public static clear() {
    this._backward = []
  }
}
